import { useEffect, useState } from "react";
import { getMyApprovalSummary } from "../../api/approval";
import { useNavigate, useParams } from "react-router-dom";
import WidgetCard from "./WidgetCard";

export default function ApprovalWidget() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { id: projectId } = useParams();

  useEffect(() => {
    const load = async () => {
      try {
        const res = await getMyApprovalSummary();
        console.log("###", res.data)
        setData(res.data);
      } catch (err) {
        console.error("결재 현황 불러오기 실패:", err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [projectId]);

  if (loading)
    return (
      <WidgetCard title="결재 현황">
        <div className="text-sm text-gray-500">결재 현황 불러오는 중...</div>
      </WidgetCard>
    );

  if (!data)
    return (
      <WidgetCard title="결재 현황">
        <div className="text-sm text-gray-500">
          결재 현황을 가져올 수 없습니다.
        </div>
      </WidgetCard>
    );

  const { summary, waiting_list } = data;

  return (
    <WidgetCard
      title="결재 현황"
      linkText="전체보기"
      onLinkClick={() => navigate(`/project/${projectId}/approval/mydocs`)}
    >
      {/* 상단 3개 요약 숫자 */}
      <div className="grid grid-cols-3 text-center pb-2">
        <div>
          <div className="text-xl font-bold text-yellow-600">{summary?.waiting ?? 0}</div>
          <div className="text-sm text-gray-500">결재 대기</div>
        </div>

        <div>
          <div className="text-xl font-bold text-green-600">{summary?.approved ?? 0}</div>
          <div className="text-sm text-gray-500">승인 완료</div>
        </div>

        <div>
          <div className="text-xl font-bold text-red-600">{summary?.rejected ?? 0}</div>
          <div className="text-sm text-gray-500">반려됨</div>
        </div>
      </div>

      {/* 대기 문서 리스트 */}
      <div className="border-t pt-3">
        <h4 className="text-sm font-medium text-gray-600 mb-2">
          내가 결재해야 할 문서
        </h4>

        {waiting_list?.length > 0 ? (
          <ul className="space-y-1 text-sm">
            {waiting_list.map((doc) => (
              <li
                key={doc.dns}
                onClick={() => {
                  const key = doc.id || doc.dns || doc.docs_dns;
                  const module =
                    doc.module === "construction"
                      ? "const"
                      : doc.module || "approval";

                  const doc_type = doc.doc_type;

                  navigate(`/project/${projectId}/${module}/${doc_type}/${key}/view`);
                }}
                className="flex justify-between items-center hover:bg-gray-50 p-1 rounded cursor-pointer"
              >
                <div className="flex items-center gap-2 truncate max-w-[180px]">
                  <span className="font-medium text-gray-800 truncate">
                    {doc.title || doc.dns}
                  </span>

                  {doc.is_urgent && (
                    <span className="text-[10px] font-semibold text-red-600 bg-red-100 border border-red-300 px-1.5 py-0.3 rounded">
                      긴급
                    </span>
                  )}
                </div>

                <span className="text-xs text-gray-400 whitespace-nowrap">
                  {new Date(doc.created_at).toLocaleDateString()}
                </span>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-xs text-gray-400">결재 대기 문서가 없습니다.</p>
        )}
      </div>
    </WidgetCard>
  );
}
